// src/lib/intake/intakeYears.js
//
// Ticket 061 (Advisor Intake I4). The tax years the intake offers (design
// decision D4, plan D-OD5). A browser copy of the Snapshot rule
// (useTriageForm.js buildTaxYearOptions): the current year, next year, and the
// prior year until 30 June. The window itself is built once in intakeConfig
// (intakeBaseYears), which also gives the move-date cutoff C (its oldest year). A test ties it to the server window
// (supabase/functions/_shared/intake/intakeYears.ts: current-2 to current+1).
//
// `today` is a parameter so tests can inject a date. Read in UTC, like the server.
//
// move = { branch, year } from the move-date screen.
//   branch 'before' (or none yet): the base list, unfiltered.
//   branch 'recent': only years >= the move year (the Snapshot filter). The
//   Snapshot's far-future branch is NOT copied: the move-year choices stop at
//   currentYear + 1, so it cannot occur.

import { intakeBaseYears } from './intakeConfig'

export function intakeTaxYearOptions(today = new Date(), move = null) {
  const base = intakeBaseYears(today)
  if (move && move.branch === 'recent' && move.year) {
    const moveYear = Number(move.year)
    if (Number.isInteger(moveYear)) return base.filter((y) => y >= moveYear)
  }
  return base
}
